import { render, staticRenderFns } from "./ScoreDetails.vue?vue&type=template&id=7c7f549a&scoped=true&"
import script from "./ScoreDetails.vue?vue&type=script&lang=js&"
export * from "./ScoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDetails.vue?vue&type=style&index=0&id=7c7f549a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f549a",
  null
  
)

export default component.exports